import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadProgressComponent } from 'src/app/shared/components/upload-progress/upload-progress.component';
import { RsbService } from 'src/app/service/rsb.service';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { ImageCropperComponent } from 'src/app/shared/components/image-cropper/image-cropper.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-companyimages',
  templateUrl: './companyimages.component.html',
  styleUrls: ['./companyimages.component.css']
})
export class CompanyimagesComponent implements OnInit {

  @Output() showNextPage: EventEmitter<number> = new EventEmitter();
  propertyImages: Array<string> = [
    '',
    '',
    '',
    '',
    '',
    ''
  ];
  selectedProperty: any;

  constructor(
    private modalService: NgbModal,
    private rsbService: RsbService,
    private lookupModel: RsbLookupModel,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.selectedProperty = this.lookupModel.getBuilderCompany() ? this.lookupModel.getBuilderCompany() : null;
    if (this.selectedProperty && this.selectedProperty.images) {
      this.propertyImages = this.selectedProperty.images;
    }
  }

  uploadAws(event: any, index: number): void {
    const mdlRef = this.modalService.open(ImageCropperComponent, { windowClass: 'signInForm' });
    mdlRef.componentInstance.imageChangedEvent = event;
    mdlRef.result.then((cropResp: { image: any, markDefault: boolean }) => {
      if (cropResp && cropResp.image) {
        const modalRef = this.modalService.open(UploadProgressComponent, { windowClass: 'signInForm' });
        modalRef.componentInstance.file = cropResp.image;
        modalRef.result.then((path: any) => {
          if (path) {
            if (this.propertyImages[index]) {
              this.propertyImages[index] = path?.image;
            } else {
              const imageList = this.propertyImages.filter(item => item !== '');
              if (cropResp.markDefault) {
                imageList.unshift(path?.image);
                this.selectedProperty.propertyPreviewImage = path?.image;
              } else {
                imageList.push(path?.image);
              }
              if (imageList.length < 6) {
                const length = 6 - imageList.length;
                for (var i = 0; i < length; i++) {
                  imageList.push('');
                }
              }
              this.propertyImages = imageList;
            }
          }
        });
      }
    });
  }

  submit(): void {
    let property = this.lookupModel.getBuilderCompany();
    property.images = this.propertyImages;
    this.lookupModel.setBuilderCompany(property);
    if (!property.companyId) {
      this.rsbService.addBuilderCompany(property).subscribe((rsp) => {
        if (rsp.statusCode === 0) {
          this.router.navigate(['myCompany'])
        }
      })
    } else {
      this.rsbService.updateBuilderCompany(property).subscribe((rsp) => {
        if (rsp.statusCode === 0) {
          this.router.navigate(['myCompany'])
        }
      })
    }
  }



}
